import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import TitlePages from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";

const ObligacionesE = () => {
  useEffect(() => {
    document.title = "Obligaciones Específicas";
  }, []);

  return (
    <>
      <Breadcrumbs
        path={[
          { label: "Transparencia", url: "/Transparencia" },
          { label: "Obligaciones Específicas" },
        ]}
      />

      <TitlePages
        title="Obligaciones de Transparencia Específicas"
        description="Ley de Transparencia y Acceso a la Información Pública del Estado de Tlaxcala."
      />

      <div className="w-100 mt-5 Grid__folder">
        <div className="margin-bottom-1">
          <Link to="/ObligacionesE2026">
            <img
              className="img-fluid"
              src="https://itetlax.org.mx/assets/img/icons/2026.png"
              alt="Obligaciones Específicas (2026)"
            />
          </Link>
        </div>
      </div>
    </>
  );
};

export default ObligacionesE;